import React from 'react';
import { Fade } from 'react-awesome-reveal';
import {
    FaPython, FaJs, FaHtml5, FaCss3Alt, FaDocker, FaGitAlt, FaGithub, FaDatabase,
    FaCode, FaBrain, FaRobot, FaCertificate
} from 'react-icons/fa';
import {
    SiCplusplus, SiPytorch, SiScikitlearn, SiMongodb, SiStreamlit,
    SiNumpy, SiPandas, SiFlask, SiFastapi, SiLangchain
} from 'react-icons/si';

const SkillsPage = () => {
    const skillCategories = [
        {
            title: "Languages",
            skills: [
                { name: "Python", icon: <FaPython /> },
                { name: "C++", icon: <SiCplusplus /> },
                { name: "SQL", icon: <FaDatabase /> },
                { name: "JavaScript", icon: <FaJs /> },
                { name: "HTML", icon: <FaHtml5 /> },
                { name: "CSS", icon: <FaCss3Alt /> }
            ]
        },
        {
            title: "AI & ML",
            skills: [
                { name: "Machine Learning", icon: <FaBrain /> },
                { name: "Deep Learning", icon: <FaBrain /> },
                { name: "NLP", icon: <FaRobot /> },
                { name: "Generative AI", icon: <FaRobot /> },
                { name: "RAG", icon: <FaCode /> },
                { name: "Prompt Engineering", icon: <FaCode /> },
                { name: "LLM Evaluation", icon: <FaCode /> },
                { name: "Model Inference", icon: <FaBrain /> },
                { name: "Vector Databases", icon: <FaDatabase /> },
                { name: "Embeddings", icon: <FaCode /> },
                { name: "Google Gemini", icon: <FaRobot /> },
                { name: "MCP", icon: <FaCode /> }
            ]
        },
        {
            title: "Frameworks & Tools",
            skills: [
                { name: "PyTorch", icon: <SiPytorch /> },
                { name: "Scikit-learn", icon: <SiScikitlearn /> },
                { name: "Hugging Face", icon: <FaRobot /> },
                { name: "LangChain", icon: <SiLangchain /> },
                { name: "LangGraph", icon: <FaCode /> },
                { name: "RAGAS", icon: <FaCode /> },
                { name: "FastAPI", icon: <SiFastapi /> },
                { name: "Flask", icon: <SiFlask /> },
                { name: "Docker", icon: <FaDocker /> },
                { name: "MongoDB", icon: <SiMongodb /> },
                { name: "FAISS", icon: <FaDatabase /> },
                { name: "Chroma", icon: <FaDatabase /> },
                { name: "Pandas", icon: <SiPandas /> },
                { name: "NumPy", icon: <SiNumpy /> },
                { name: "Streamlit", icon: <SiStreamlit /> },
                { name: "Git", icon: <FaGitAlt /> },
                { name: "GitHub", icon: <FaGithub /> },
                { name: "n8n", icon: <FaCode /> }
            ]
        }
    ];

    const certifications = [
        {
            title: "Agentic AI using LangGraph",
            provider: "Udemy",
            link: "https://www.udemy.com/certificate/UC-f7fbeecd-359c-47d0-a697-ccfc21c99f92/",
            icon: <FaCertificate />
        },
        {
            title: "Basic RAG using LangChain & LangGraph",
            provider: "Udemy",
            link: "https://www.udemy.com/certificate/UC-a5d55ba4-5098-4f05-bc79-af472454eda2/",
            icon: <FaCertificate />
        },
        {
            title: "Gen AI using IBM WatsonX",
            provider: "IBM Developer Skills Network",
            link: "https://courses.vit.skillsnetwork.site/certificates/a15d53b8cb1043aba05ac74711fd9081",
            icon: <FaCertificate />
        },
        {
            title: "Applied Machine Learning in Python",
            provider: "Coursera",
            link: "https://www.coursera.org/account/accomplishments/verify/SGMHQOAWF4L2",
            icon: <FaCertificate />
        },
        {
            title: "Data Science using Python",
            provider: "iamneo",
            link: "https://vit162.examly.io/certificate/U2FsdGVkX1%2FSO3F11Fkno3UWTSHwoGG9xv6xCOBt2Ew%3D",
            icon: <FaCertificate />
        }
    ];

    return (
        <div className="page-container skills-page">
            <Fade triggerOnce duration={800}>
                <h1 className="page-title">Skills & Technologies</h1>
            </Fade>

            {skillCategories.map((category, catIndex) => (
                <Fade key={catIndex} triggerOnce duration={600} delay={catIndex * 100}>
                    <section className="skill-category">
                        <h2 className="category-title">{category.title}</h2>
                        <div className="skills-grid">
                            {category.skills.map((skill, skillIndex) => (
                                <div key={skillIndex} className="skill-card">
                                    <span className="skill-icon">{skill.icon}</span>
                                    <span className="skill-name">{skill.name}</span>
                                </div>
                            ))}
                        </div>
                    </section>
                </Fade>
            ))}

            <Fade triggerOnce duration={600} delay={400}>
                <section className="certifications-section">
                    <h2 className="category-title">Certifications</h2>
                    <div className="certifications-grid">
                        {certifications.map((cert, index) => (
                            <a
                                key={index}
                                href={cert.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="certification-card"
                            >
                                <span className="cert-icon">{cert.icon}</span>
                                <div className="cert-info">
                                    <h3 className="cert-title">{cert.title}</h3>
                                    <p className="cert-provider">{cert.provider}</p>
                                </div>
                            </a>
                        ))}
                    </div>
                </section>
            </Fade>
        </div>
    );
};

export default SkillsPage;
